<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica categoria' : 'Nuova categoria'"
                     @back="$router.replace('/categories')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Nome*"
              v-model="editingItem.name.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Abbreviato*"
              v-model="editingItem.abbrev.it"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Categoria per palestra"
              v-model="editingItem.is_gym_category"
          ></v-switch>
        </v-col>



        <form-footer @back="$router.replace('/categories')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { Category } from "@/models.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<Category>({
      desc: { it : '' }, abbrev: {it:''}, name: {it:''}, is_gym_category : true
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Category>('categories', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/categories')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      async save(goBackAfterSave:boolean) {
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Category>('categories', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("categoria salvata")
        if(goBackAfterSave) {
          await router.replace('/categories')
        } else if(route.params.id === 'new'){
          await router.replace(`/categories/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
